/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * DeleteDriverPushTokenDtoBase
 * auto generated base class for the model DeleteDriverPushTokenDtoModel.
 */
export const DeleteDriverPushTokenDtoModelBase = ModelBase
  .named('DeleteDriverPushTokenDto')
  .props({
    __typename: types.optional(types.literal("DeleteDriverPushTokenDto"), "DeleteDriverPushTokenDto"),
    userUuid: types.union(types.undefined, types.string),
    token: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class DeleteDriverPushTokenDtoModelSelector extends QueryBuilder {
  get userUuid() { return this.__attr(`userUuid`) }
  get token() { return this.__attr(`token`) }
}
export function selectFromDeleteDriverPushTokenDto() {
  return new DeleteDriverPushTokenDtoModelSelector()
}

export const deleteDriverPushTokenDtoModelPrimitives = selectFromDeleteDriverPushTokenDto().userUuid.token
